// extracted by mini-css-extract-plugin
module.exports = {"stack":"HostImageStack_stack__duwBX"};